import { XpressDisciplinaryHearingLocationsEnum } from 'app/models';

export class XpressDisciplinaryHearingLocationsModel {
    public static XpressDisciplinaryActionList: Array<any> = [
        { name: 'Xpress Brixton', value: XpressDisciplinaryHearingLocationsEnum.XpressBrixton },
        { name: 'Xpress Uptown', value: XpressDisciplinaryHearingLocationsEnum.XpressUptown },
        { name: 'Xpress Ayala', value: XpressDisciplinaryHearingLocationsEnum.XpressAyala }
    ];
}
